import cx from 'classnames';
import { appAssetsCdnUrl } from '~/constants/environment';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import { nativeSrpPayload } from '~/native/common/utils';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import optimizeImage from '~/utilities/optimizeImage';
import styles from './Cards.module.css';
import {
  CardContainer,
  CardCta,
  CardSubtitle,
  CardTitle,
  CardTitleContainer
} from './Cards.styles';

const FREE_SHIPPING_SEARCH_LINK = generateSearchLinkFilter({
  filters: { isFreeDelivery: true }
});

export default function FreeShipping() {
  const getHref = useGetConsumerHref();

  return (
    <CardContainer
      className="grid bg-background-primary p-0!"
      data-analytics-id="Free Shipping"
      data-testid="free-shipping-card"
      data-native-payload={nativeSrpPayload}
      href={getHref(FREE_SHIPPING_SEARCH_LINK)}
    >
      <div
        className="relative col-span-full row-span-full flex h-full max-h-[365px] w-full bg-cover bg-center"
        style={{
          backgroundImage: `url(${optimizeImage(
            `${appAssetsCdnUrl}/images/home/budget-free-shipping-background.jpg`,
            { height: 350, quality: 90, format: 'auto' }
          )})`
        }}
      >
        <img
          src={optimizeImage(
            `${appAssetsCdnUrl}/images/home/budget-free-shipping.png`,
            { height: 350, quality: 90, format: 'auto' }
          )}
          alt=""
          className={cx(
            'absolute top-[160px] h-[100px] w-full object-cover',
            styles.haulerImage
          )}
          loading="lazy"
        />
      </div>
      <div className="z-1 col-span-full row-span-full flex flex-col items-center justify-between p-2xl">
        <CardTitleContainer>
          <CardTitle inverse>Zero shipping costs.</CardTitle>
          <CardSubtitle inverse>
            We always have inventory near you. Explore all vehicles with no
            shipping fees.
          </CardSubtitle>
        </CardTitleContainer>
        <CardCta data-testid="shop-by-free-shipping" inverse>
          Shop by Free Shipping
        </CardCta>
      </div>
    </CardContainer>
  );
}
